const SortActionTypes = {
    UPDATE_PROJECT_SORT_SELECTION: 'UPDATE_PROJECT_SORT_SELECTION',
    UPDATE_PROJECT_SORT_ORDER: 'UPDATE_PROJECT_SORT_ORDER',
    CLEAR_PROJECT_SORT: 'CLEAR_PROJECT_SORT',

    UPDATE_TASK_SORT_SELECTION: 'UPDATE_TASK_SORT_SELECTION',
    UPDATE_TASK_SORT_ORDER: 'UPDATE_TASK_SORT_ORDER',
    CLEAR_TASK_SORT: 'CLEAR_TASK_SORT',

    CLEAR_ALL_SORTS: 'CLEAR_ALL_SORTS',
    CLEAR_ALL_GROUP_BYS: 'CLEAR_ALL_GROUP_BYS'
}

export default SortActionTypes;